const routes = [{
  path: '/AIRobot/useManual',
  component: () => import('@/views/AIRobotManage/useManual'),
  name: 'useManual',
  meta: {
    title: '使用指引'
  }
}, {
  path: '/AIRobot/takeOrderGroup',
  component: () => import('@/views/AIRobotManage/takeOrderGroup'),
  name: 'takeOrderGroup',
  meta: {
    title: '接单机器人群管理'
  }
}, {
  path: '/AIRobot/dataStatistics',
  component: () => import('@/views/AIRobotManage/dataStatistics'),
  name: 'dataStatistics',
  meta: {
    title: '数据统计'
  }
}, {
  path: '/AIRobot/replySetting',
  component: () => import('@/views/AIRobotManage/replySetting'),
  name: 'replySetting',
  meta: {
    title: '机器人设置'
  }
}, {
  path: '/AIRobot/automaticSending',
  component: () => import('@/views/AIRobotManage/automaticSending'),
  name: 'automaticSending',
  meta: {
    title: '智能发送报价单配置'
  }
}, {
  path: '/AIRobot/monitoringEarlyWarning',
  component: () => import('@/views/AIRobotManage/monitoringEarlyWarning'),
  name: 'monitoringEarlyWarning',
  meta: {
    title: '监控预警设置'
  }
}, {
  path: '/AIRobot/enterpriseWeChat',
  component: () => import('@/views/AIRobotManage/enterpriseWeChat'),
  name: 'enterpriseWeChat',
  meta: {
    title: '企业微信设置'
  }
}, {
  path: '/AIRobot/quotationSettings',
  component: () => import('@/views/AIRobotManage/quotationSettings'),
  name: 'quotationSettings',
  meta: {
    title: '机器人报价设置'
  }
}, {
  path: '/AIRobot/feeCenter',
  component: () => import('@/views/AIRobotManage/feeCenter'),
  name: 'feeCenter',
  meta: {
    title: '费用中心'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/AIRobot.js